"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroupType = exports.Group = void 0;
var uuid_1 = require("uuid");
var node_1 = require("../questionnaire/node");
var Group = /** @class */ (function () {
    function Group(arg) {
        this.id = arg.id || (0, uuid_1.v1)();
        this.nodes = arg.nodes;
        if (arg.repetitions) {
            this.repetitions = arg.repetitions;
        }
        else {
            this.repetitions = 1;
        }
        if (arg.answers) {
            this.answers = arg.answers;
        }
    }
    return Group;
}());
exports.Group = Group;
var isGroupType = function (type) {
    var groupTypes = [
        node_1.NODE_TYPES.GROUP_AB,
        node_1.NODE_TYPES.GROUP_BASIC,
        node_1.NODE_TYPES.GROUP_CONJOINT,
        node_1.NODE_TYPES.GROUP_VAN_WESTENDORP,
        node_1.NODE_TYPES.GROUP_MAXDIFF,
    ];
    if (groupTypes.includes(type)) {
        return true;
    }
    return false;
};
exports.isGroupType = isGroupType;
